import { ViewModel,View, ViewModelMessage } from "binder"
import { ShowMessageBoxMessage, ShowPopupMessage } from "src/binder/uiPatterns/mvvm/viewmodel";
import { MessageBoxViewModel, singleButton } from "../messageBox/messageBox-viewModel";
import { IPopup } from "./IPopup";
import  { WindowContainerView } from "./windowContainer-view"

export class WindowContainerViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new WindowContainerView();
    }
    public getTypeId(): string {
        return "VM-AC47C76B-664B-47B1-9ED6-94676E849F0C"
    }

    public set window(v: WindowViewModel) { 
        this._window = v; 
        if(v) v._container = this;
        if(v['refresh']==null){
            this.canRefresh=false;
        }else{
            this.canRefresh = true;
        }
    } public get window(): WindowViewModel { return this._window;} private _window: WindowViewModel;
    public set isShowingMessageBox(v: boolean) { this._isShowingMessageBox = v; } public get isShowingMessageBox(): boolean { return this._isShowingMessageBox;} private _isShowingMessageBox: boolean;
    public set msgViewModel(v: MessageBoxViewModel) { this._msgViewModel = v; } public get msgViewModel(): MessageBoxViewModel { return this._msgViewModel;} private _msgViewModel: MessageBoxViewModel;
    public set canRefresh(v: boolean) { this._canRefresh = v; } public get canRefresh(): boolean { return this._canRefresh;} private _canRefresh: boolean;
    
    refresh(){
        (<any>this.window).refresh();
    }
    close(){
        if(this.window.requestClose()){
            let message = new RequestCloseWindowMessage();
            message.window = this;
            this.handleMessage(message);
        }
    }

    closeMessageBox() {
        this.isShowingMessageBox = false;
        this.msgViewModel = null;
    }
    public handleMessage(message: ViewModelMessage) {
        if(message instanceof ShowMessageBoxMessage){
            let messageBox = new MessageBoxViewModel(this);
            messageBox.type = message.type;
            messageBox.title = message.title;
            messageBox.messsage = message.message;
            messageBox.resolveFunction = message.resolveFunction;
            messageBox.buttons.update(...message.buttons.map(x=>{
                let b = new singleButton(messageBox);
                b.className = x.className;
                b.resultCode = x.resultCode;
                b.title = x.title;
                return b;
            }))
            this.msgViewModel = messageBox;
            this.isShowingMessageBox = true;
            return null;
        }else if(message instanceof RequestRefreshMessage){
            this.refresh();
        }else{
            return super.handleMessage(message);
        }
    }
}

export class RequestRefreshMessage extends ViewModelMessage{

}
export class RequestCloseWindowMessage extends ViewModelMessage{
    public window : any;
}



export abstract class PopupContainerViewModel extends ViewModel{
    constructor(parent:ViewModel) {
        super(parent);
        this.popupStack = [];
    }
    public popupChanging(popup:IPopup,autoHide:boolean,additionalInfo:any){

    }
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    private popupStack : {popup:IPopup,autoHide:boolean,additionalInfo:any}[];
    showPopup(popup:IPopup,autoHide:boolean=true,additionalInfo:any=null):Promise<any>{
        this.popupStack.unshift({popup:popup,autoHide:autoHide,additionalInfo:additionalInfo});
        let result = new Promise<string>((resolve,reject)=>{
            popup.closePopup = x=>{
                if(autoHide==true){
                    this.isShowingPopup = false;
                    this.popupStack = [];
                }
                else{
                    this.popupStack.shift();
                    if(this.popupStack.length==0){
                        this.isShowingPopup = false;
                    }else{
                        this.popupChanging(this.popup,this.popupStack[0].autoHide,this.popupStack[0].additionalInfo);
                        this.popup = this.popupStack[0].popup;
                    }    
                }
                resolve(x);
                
            };
            this.popupChanging(this.popup,autoHide,additionalInfo);
            this.popup = popup;
            this.isShowingPopup = true;
        });
        return result;
    }

    public handleMessage(message: ViewModelMessage) {
        if(message instanceof ShowPopupMessage){
            return this.showPopup(message.popup,message.autoHide,message.additionalInfo);
        }else{
            return super.handleMessage(message);
        }
    }
}
export abstract class WindowViewModel extends PopupContainerViewModel{
    constructor(parent:ViewModel) {
        super(parent);
    }

    override RealConstructor(parentViewModel){
        super.RealConstructor(parentViewModel);
        this.title = this.getTitle();
    }

    public abstract getTitle():string;
    public _container : WindowContainerViewModel;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    
    requestClose():boolean{
        return true;
    }

    close(){
        let message = new RequestCloseWindowMessage();
        message.window = this._container;
        this.handleMessage(message);
    }
}
